export default "__VITE_ASSET__58c6cba1__"